import "react-app-polyfill/ie11";
import "core-js/actual";

import dayjs from "dayjs";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import { UserManager } from "oidc-client-ts";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "react-oidc-context";

import "dayjs/locale/cs";

import "./index.css"; //musi byt pred custom importy

import config from "./config";
import App from "./containers/app";
import setting from "../package.json";
import store from "./modules/redux/store";
import { KEYCLOAK_CONFIG } from "./keycloak";
import { saveUserFromKeycloak } from "./modules/userSession";

dayjs.locale("cs");

export const datePickerFormat = "D.M.YYYY";
export const dateTimePickerFormat = "D.M.YYYY HH:mm:ss";
export const dateTimeApiFormat = "YYYY-MM-DDTHH:mm:ssZ"; //pripadne bez Z na konci

export let userManager = new UserManager({
  authority: KEYCLOAK_CONFIG.url,
  client_id: KEYCLOAK_CONFIG.clientId,
  redirect_uri: window.location.origin + setting.homepage,
  post_logout_redirect_uri: config.URL,
});

Sentry.init({
  dsn: config.SENTRY_URL,
  environment: window.location.host.startsWith("app-")
    ? window.location.host.substring(4, 8)
    : window.location.host.startsWith("localhost")
    ? "development"
    : "prod",
  release: "e-contract-frontend:fe@" + setting.version,
  ignoreErrors: [
    /^.*ResizeObserver.*$/,
    "Non-Error promise rejection captured with value: true",
  ],
});

/^(\/[A-Z]|file):/.test(window.location.href) &&
  window.location.replace(config.PROD_URL);

const node = document.getElementById("nonce-value");
document.head.querySelector('meta[property="csp-nonce"]').content = node
  ? node.getAttribute("value")
  : "";

const root = createRoot(document.getElementById("root"));
root.render(
  <AuthProvider
    automaticSilentRenew
    userManager={userManager}
    onSigninCallback={(response) => {
      saveUserFromKeycloak(null, response);
      window.history.pushState({}, document.title, window.location.pathname);
    }}
  >
    <Provider store={store}>
      <BrowserRouter basename={setting.homepage}>
          <App />
      </BrowserRouter>
    </Provider>
  </AuthProvider>
);
